export default {
  // Mapping custom validator keys to the correct translation keys
  alreadyHasCard: 'api.error.10320',
  cardAlreadyAssigned: 'api.error.10310',
  day: 'VALIDATIONS.validDay',
  emailFormat: 'VALIDATIONS.invalidEmail',
  internationalPhoneFormat: 'VALIDATIONS.phoneFormat',
  invalidCard: 'api.error.10301',
  invalidEmailOrUsername: 'VALIDATIONS.invalidEmailOrUsername',
  isFuture: 'VALIDATIONS.PastDate',
  prefix: 'VALIDATIONS.required',
  prefixAndPhoneRequired: 'VALIDATIONS.required',
  sameAsPassword: 'COMMON.PASSWORDS_DO_NOT_MATCH',
  usernameFormat: 'VALIDATIONS.INVALID_USERNAME',
  validTrackingUrl: 'VALIDATIONS.invalidUrl',
  validUrl: 'VALIDATIONS.invalidUrl',
  year: 'VALIDATIONS.validYear',
  numeric: 'VALIDATIONS.invalidCharacter',
  maxFileSize: 'VALIDATIONS.maxFileSize',
}
